export default {"src":"/_next/static/media/cad.23924e59.svg","height":512,"width":513};